module.exports = __webpack_public_path__ + "img/bq.4f3b5a62.svg";